import { Component, OnInit, ViewContainerRef, ComponentRef } from '@angular/core';
import { ModalDialogService } from 'ngx-modal-dialog';
import { FormControl, NgModel } from '@angular/forms';
import * as $ from 'jquery';
import { authenticaitonModel } from '../authentication/model/authenticaiton.model';
import { ListOrderTracking, OrderStatusModel } from './model/order-traking.model';
import { OrderTrackingService } from './services/order-tracking.service';


@Component({
  selector: 'app-order-tracking-component',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.css']
})

export class OrderTrackingComponent implements OnInit {
  public orderTrackings: ListOrderTracking[];
  public orderTracking: object;
  public orderTrackingType: string;
  public orderTrackingIconModal: string;
  public orderTrackingIconTitleModal: string;
  public orderTrackingMessageModal: string;
  public pageSize: number = 5;
  public p: number = 1;
  public total: number = 40;
  public txtSearch: string = "*";
  public lastElement: object = null;
  public modalService: ModalDialogService;
  public viewRef: ViewContainerRef;
  public loading: boolean;
  currentUser: authenticaitonModel = null;
  orderTrackingItemSelected = null;

  orderStatusFiltered: OrderStatusModel[] = [
    { id: "order-received", name: "Pedido Recebido" }, // false
    { id: "order-in-separation", name: "Pedido em separação" }, // false
    { id: "order-awaiting-pickup", name: "Pronto para retirada" }, //false
    { id: "order-invoiced", name: "Pedido faturado" }, // false
    { id: "order-in-transit", name: "Pedido em rota de entrega" }, // false
    { id: "order-delivered", name: "Pedido entregue" }, // true
    { id: "order-canceled", name: "Pedido cancelado" }, // true
    { id: "order-canceled-without-stock", name: "Pedido cancelado por falta de estoque" }, // true
    { id: "order-credit-analysis-rejected", name: "Análise de crédito rejeitada" }, // false
    { id: "order-payment-canceled", name: "Pagamento não autorizado" }, // true 
    { id: "not-integrated", name: "Pedido não integrado" }, // true
    { id: "not-ax-integrated", name: "Pedido não integrado no ax" }, // true
    { id: "awaiting-release", name: "Aguardando liberação" } // true
  ];
  filterOrderStatesSelected: any[] = [
    "order-received", // false
    "order-in-separation", // false
    "order-awaiting-pickup", //false
    "order-invoiced",  // false
    "order-in-transit", // false
    "", // true
    "", // true
    "", // true
    "order-credit-analysis-rejected", // false
    "", // true 
    "not-ax-integrated", // true
    "not-integrated", // true
    "awaiting-release", // true
  ];
  registerLimite: boolean = false;
  public processingConfirmation: string;
  public modalMessageTitle: string;
  public modalMessageText: string;

  constructor(
    modalService: ModalDialogService,
    viewRef: ViewContainerRef,
    private orderTrakingService: OrderTrackingService
  ) {
    this.modalService = modalService;
    this.viewRef = viewRef;
  }

  public doSearch($event: Event) {
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.p = 1;
    this.getOrders(this.p);
  }

  public doSearchClear() {
    this.txtSearch = "*";
    this.getOrders(this.p);
  }

  public refrehPage() {
    this.getOrders(this.p);
  }

  public applyFilter($event) {
    if ($event)
      return; // Caso selec seja aberto
    this.p = 1;
    this.getOrders(this.p);
  }

  public registerLimiteChange() {
    this.registerLimite = !this.registerLimite;
    this.p = 1;
    this.getOrders(this.p);
  }

  public getOrders(page) {
    if (page == 0)
      page = 1;
    this.p = page;
    this.loading = true;
    return this.orderTrakingService.getTrakingService(page, this.txtSearch, this.filterOrderStatesSelected.join(','), this.registerLimite)
      .subscribe(result => {
        try {
          this.loading = false;
          this.orderTrackings = result.listOrderTracking;
          this.orderTracking = result.listOrderTracking[0];
          this.pageSize = result["pageSize"];
          this.p = result["currentPage"];
          this.total = result["totalRecords"];
        } catch (er) {
          this.loading = false;
          this.orderTrackings = [];
          this.orderTracking = {};
          this.pageSize = result["pageSize"];
          this.p = 1;
          this.total = result["totalRecords"];
        }
      });
  }

  public modalReprocess(modal, orderTrackingItem) {
    this.orderTrackingItemSelected = orderTrackingItem;
    document.getElementById(modal).style.display = "block";
    document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    document.getElementById(modal).style.backgroundColor = 'transparent';
  }

  public modalMessage(modal, title, text) {
    this.modalMessageTitle = title;
    this.modalMessageText = text;
    document.getElementById(modal).style.display = "block";
    document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    document.getElementById(modal).style.backgroundColor = 'transparent';
  }

  public reprocessOrdemItemModalReprocess() {
    if (this.orderTrackingItemSelected === null) {
      this.closeModal("modalReprocessOrdemItemTrackingCard");
      this.modalMessage("modalMessage", "Alerta", "Houve um problema na seleção do registro, por favor, refaça o processo. Caso o problema persista, contato o suporte.");
      this.processingConfirmation = "";
      return;
    }

    if (this.processingConfirmation === "1") {
      this.loading = true;
      return this.orderTrakingService.updateTrakingService(this.orderTrackingItemSelected.id)
        .subscribe(result => {
          if (result && result["returnCode"] && result["returnCode"] !== "") {
            this.closeModal("modalReprocessOrdemItemTrackingCard");
            this.modalMessage("modalMessage", "Erro", result["returnMessage"]);
            this.loading = false;
          } else {
            this.closeModal("modalReprocessOrdemItemTrackingCard");
            this.modalMessage("modalMessage", "Pedido reprocessado", "Seu pedido para reprocessamento foi concluído com sucesso");
            this.refrehPage();
          }
          this.processingConfirmation = "";
        }, error => {
          this.closeModal("modalReprocessOrdemItemTrackingCard");
          this.modalMessage("modalMessage", "Erro", error.error.substring(0, 500));
          this.processingConfirmation = "";
          this.loading = false;
        });
    } else {
      this.closeModal("modalReprocessOrdemItemTrackingCard");
    }

    this.processingConfirmation = "";
  }

  public setOrderItemTracking(index, orderTrackingType) {
    this.orderTracking = this.orderTrackings[index];
    this.orderTrackingType = orderTrackingType;
    this.orderTrackingMessageModal = '';
  }

  public openModal(modal, orderTrackingType, index, event) {
    document.getElementById(modal).style.display = "block";
    document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    document.getElementById(modal).style.width = 'auto';
    document.getElementById(modal).style.height = 'auto';
    document.getElementById(modal).style.backgroundColor = 'transparent';


    var modalElem = $("#" + modal);
    //modalElem.draggable();
    document.getElementById(modal).style.left = ((event.view.innerWidth / 4) - modalElem.width() / 2) + 'px';
    document.getElementById(modal).style.top = ((event.view.innerHeight / 2) - modalElem.height() / 2) + 'px';

    var tdSelected = $(event.currentTarget).parent().parent();
    if (tdSelected.prop("tagName") !== "TD") {
      tdSelected = tdSelected.parent();
    }

    if (this.lastElement !== null)
      $(this.lastElement).css("background-color", "transparent");
    tdSelected.css("background-color", "#F7FFF6");
    this.lastElement = tdSelected[0];

    this.setOrderItemTracking(index, orderTrackingType);
  }

  public closeModal(modal) {
    if (this.lastElement !== null)
      $(this.lastElement).css("background-color", "transparent");
    document.getElementById(modal).style.display = "none";
    this.processingConfirmation = "";
    //this.loading = false;
  }

  public pageChanged(event) {
    this.closeModal("modalDetailOrdemItemTrackingCard");
    this.getOrders(event);
  }

  public selectAll(select: NgModel, values) {
    if (this.filterOrderStatesSelected && this.filterOrderStatesSelected.length > 0) {
      values = [];
    }
    select.update.emit(values.map(region => { return region.id }));
    //this.regionChecked();
  }

  public regionChecked() {
    if (this.filterOrderStatesSelected.length === 0) {
      // this.clearRegionClick();
    }
    //this.getOrders(1)
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }
    this.getOrders(1);
  }

  loggedUser() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser && this.currentUser.userPermission) {
      return true;
    }
  }
}
